import React from 'react';
import { Star } from 'lucide-react';
import { useReviews } from '../../context/ReviewContext';

const RatingDisplay = ({ productId, size = 'small', showCount = true }) => {
  const { getProductRating } = useReviews();
  const rating = getProductRating(productId);

  const starSize = size === 'large' ? 20 : size === 'medium' ? 16 : 12;
  const fontSize = size === 'large' ? '16px' : size === 'medium' ? '14px' : '12px';

  const renderStars = (rating) => {
    return (
      <div style={{ display: 'flex', gap: '2px' }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            size={starSize}
            style={{
              color: star <= Math.round(rating) ? '#f59e0b' : '#374151',
              fill: star <= Math.round(rating) ? '#f59e0b' : 'transparent'
            }}
          />
        ))}
      </div>
    );
  };

  // Hide entirely until the product has at least one review, rather than showing empty stars.
  if (rating.count === 0) {
    return null;
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {renderStars(rating.average)}
      <span style={{ color: '#f59e0b', fontSize: fontSize, fontWeight: 'bold' }}>
        {rating.average}
      </span>
      {showCount && (
        <span style={{ color: '#9ca3af', fontSize: fontSize }}>
          ({rating.count} review{rating.count !== 1 ? 's' : ''})
        </span>
      )}
    </div>
  );
};

export default RatingDisplay;
